export function easeOutQuadratic(t) {
  return t * (2 - t);
}
// Adapted from
// https://github.com/d3/d3-ease/blob/master/src/elastic.js#L18
export const elasticOut = (function () {
  const tau = 2 * Math.PI,
    a = 1,
    p = 0.3 / tau,
    s = Math.asin(1) * p;
  return function elasticOut(t) {
    return 1 - a * Math.pow(2, -10 * (t = +t)) * Math.sin((t + s) / p);
  };
})();

function tpmt(x) {
  return (Math.pow(2, -10 * x) - 0.0009765625) * 1.0009775171065494;
}

export function easeOutExpo(t) {
  return 1 - tpmt(t);
}

// Or alternatively, use this simplified version:
export function easeOutExpoSimplified(t) {
  return t === 1 ? 1 : 1 - Math.pow(2, -10 * t);
}